import maskHelper from './maskHelper'

export default {
  bind(el, binding, vnode) {
    let input = el.querySelector('input')
    if (input && !input.hasAttribute('readonly')) {
  
      
      maskHelper(input, binding.value)
    }
  }
}
